module.exports = __webpack_public_path__ + "img/logo-pix-payment.1408e39a.svg";